(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nordskal-model-finder"] && !Shopify.designMode) return;
  try {
    (() => {
  const init = (scope = document) => {
    const roots = [...scope.querySelectorAll('[data-ns-model-finder]')];
    if (scope.matches?.('[data-ns-model-finder]')) roots.unshift(scope);
    roots.forEach((root) => {
      if (root.dataset.nsReady === 'true') return;
      const form = root.querySelector('[data-ns-finder-form]');
      const brand = root.querySelector('[data-ns-brand]');
      const model = root.querySelector('[data-ns-model]');
      const submit = root.querySelector('[data-ns-submit]');
      const status = root.querySelector('[data-ns-status]');
      const links = [...root.querySelectorAll('[data-ns-model-link]')];
      if (!form || !brand || !model || !submit || !status || !links.length) return;
      const entries = links.map((link) => ({
        brand: link.dataset.brand,
        label: link.textContent.trim(),
        href: link.getAttribute('href')
      }));
      const updateBrand = () => {
        model.replaceChildren(new Option(form.dataset.placeholder, ''));
        const matching = entries.filter((entry) => entry.brand === brand.value);
        matching.forEach((entry) => model.add(new Option(entry.label, entry.href)));
        model.disabled = matching.length === 0;
        submit.disabled = true;
        status.textContent = matching.length ? form.dataset.chooseModel : form.dataset.chooseBrand;
      };
      brand.addEventListener('change', updateBrand);
      model.addEventListener('change', () => {
        const valid = entries.some((entry) => entry.brand === brand.value && entry.href === model.value);
        submit.disabled = !valid;
        status.textContent = valid ? form.dataset.ready : form.dataset.chooseModel;
      });
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        const target = entries.find((entry) => entry.brand === brand.value && entry.href === model.value);
        if (target) window.location.assign(target.href);
      });
      updateBrand();
      root.dataset.nsReady = 'true';
      form.hidden = false;
      root.querySelectorAll('[data-ns-directory-brand]').forEach((details) => { details.open = false; });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
